import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';
import { ASTRO_DIM_TW } from '../../../../../../../utils/constantFeatures';
import { InputTime } from './InputTime';

class PropertyTableTimePickerTW extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== property.valueMeta.off;
    }

    handleChange(e) {
        e.preventDefault();
        const value = e.target.value;
        const name = e.target.name;
        if (value === null || value === '') {

            return;
        }

        this.props.handleChange(name, value);
    }

    renderFirstRow(type) {
        // Output

        const columns = [];

        if(this.props.displayColors){
            columns.push(
                <Row style={{ margin: this.props.margin }}>
                    <Col sm={8} md={8} lg={8} style={{  }} key={`${type}0`}>
                        <input
                            id={`${type}0`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}0`}
                            type="number"
                            min={0}
                            max={0}
                            value={0} />
                    </Col>
                    <Col sm={4} md={4} lg={4}>%</Col>
                </Row>
            );
        }

        //Object.keys(this.props.properties).sort().forEach((key) => {
        Object.keys(this.props.properties).sort( (a, b) => parseInt(a.replace(/\D+/g, '')) - parseInt(b.replace(/\D+/g, '')) ).forEach((key) => {

            if (this.props.properties[key].info.name.includes(type)) {
                if(this.props.properties[key].value === 'Off'){
                    this.props.properties[key].value = 0
                }
                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                columns.push(
                    <Row style={{ margin: this.props.margin }}>
                        <Col sm={8} md={8} lg={8} style={{  }} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled={this.props.disabled}
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="number"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={this.props.properties[key].value}
                                onChange={this.handleChange} />
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                        <Col sm={4} md={4} lg={4}>%</Col>
                    </Row>
                );
            }

        });

        columns.push(
            <Row style={{ margin: this.props.margin }}>
                <Col sm={8} md={8} lg={8} style={{  }} key={`${type}11`}>
                    <input
                        id={`${type}11`}
                        disabled
                        className={'input-property-picker'}
                        name={`${type}11`}
                        type="number"
                        min={0}
                        max={0}
                        value={0} />
                </Col>
                <Col sm={4} md={4} lg={4}>%</Col>
            </Row>
        );

        return columns;
    }

    renderSecondRow(type) {
        // Time

        const columns = [];

        if(this.props.displayColors){
            columns.push(
                <Row style={{ margin: this.props.margin }}>
                    <Col sm={8} md={8} lg={8} key={`${type}0`}>
                        <input
                            id={`${type}0`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}0`}
                            type="text"
                            min={0}
                            max={0}
                            value={'OFF'} />
                    </Col>
                    <Col sm={4} md={4} lg={4}>hh:mm</Col>
                </Row>
            );
        }

        columns.push(
            <Row style={{ margin: this.props.margin }}>
                <Col sm={8} md={8} lg={8} key={`${type}1`}>
                    <input
                        id={`${type}1`}
                        disabled
                        className={'input-property-picker'}
                        name={`${type}1`}
                        // type="time"
                        type="text"
                        value={this.props.properties[ASTRO_DIM_TW.submode].value === "0" ? 'ON' : '00:00'} />
                </Col>
                <Col sm={4} md={4} lg={4}>hh:mm</Col>
            </Row>
        );

        //Object.keys(this.props.properties).sort().forEach((key) => {
        Object.keys(this.props.properties).sort( (a, b) => parseInt(a.replace(/\D+/g, '')) - parseInt(b.replace(/\D+/g, '')) ).forEach((key) => {

            if (this.props.properties[key].info.name.includes(type)) {

                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                if (this.props.properties[key].info.name === ASTRO_DIM_TW.time2 && (this.props.properties[ASTRO_DIM_TW.submode].value === "2")) {
                    columns.push(
                        <Row style={{ margin: this.props.margin }}>
                            <Col sm={8} md={8} lg={8} key={this.props.properties[key].id}>
                                <input
                                    id={key}
                                    disabled={true}
                                    className={className}
                                    name={this.props.properties[key].info.name}
                                    type="text"
                                    min={this.props.properties[key].valueMeta.min}
                                    max={this.props.properties[key].valueMeta.max}
                                    value={"SD"}
                                    onChange={this.handleChange} />
                                {getIssuesComponent(errors, warnings)}
                            </Col>
                            <Col sm={4} md={4} lg={4}>hh:mm</Col>
                        </Row>
                    );
                }
                else if ( this.props.properties[ASTRO_DIM_TW.submode].value === "0" ) {
                    columns.push(
                        <Row style={{ margin: this.props.margin }}>
                            <Col sm={8} md={8} lg={8} key={this.props.properties[key].id}>
                                <input
                                    id={key}
                                    disabled={this.props.disabled}
                                    className={className}
                                    name={this.props.properties[key].info.name}
                                    type="time"
                                    min={this.props.properties[key].valueMeta.min}
                                    max={this.props.properties[key].valueMeta.max}
                                    value={this.props.properties[key].value}
                                    onChange={this.handleChange} />
                                {getIssuesComponent(errors, warnings)}
                            </Col>
                            <Col sm={4} md={4} lg={4}>hh:mm</Col>
                        </Row>
                    );
                } else {
                    columns.push(
                        <Row style={{ margin: this.props.margin }}>
                            <Col sm={8} md={8} lg={8} key={this.props.properties[key].id}>
                                <InputTime
                                    id={key}
                                    disabled={this.props.disabled}
                                    className={className}
                                    name={this.props.properties[key].info.name}
                                    value={this.props.properties[key].value}
                                    onChange={(value) => value && this.props.handleChange(this.props.properties[key].info.name, value)} />
                                {getIssuesComponent(errors, warnings)}
                            </Col>
                            <Col sm={4} md={4} lg={4}>hh:mm</Col>
                        </Row>
                    );
                }
            }
        });

        columns.push(
            <Row style={{ margin: this.props.margin }}>
                <Col sm={8} md={8} lg={8} key={`${type}11`}>
                    <input
                        id={`${type}11`}
                        disabled
                        className={'input-property-picker'}
                        name={`${type}11`}
                        type="text"
                        value={'OFF'} />
                </Col>
                <Col sm={4} md={4} lg={4}>hh:mm</Col>
            </Row>
        );

        return columns;
    }

    renderThirdRow(type) {
        // Color
        const columns = [];

        columns.push(
            <Row style={{ margin: this.props.margin }}>
                <Col sm={9} md={9} lg={9} key={`${this.props.properties['asttw.ci'].id}-0`}>
                    <input
                        style={{minWidth: '60px'}}
                        id={`${this.props.properties['asttw.ci'].id}-1`}
                        disabled={this.props.disabled}
                        className={'input-property-picker'}
                        name={this.props.properties['asttw.ci'].info.name}
                        type="number"
                        min={this.props.properties['asttw.ci'].valueMeta.min}
                        max={this.props.properties['asttw.ci'].valueMeta.max}
                        value={this.props.properties['asttw.ci'].value}
                        onChange={this.handleChange} />
                </Col>
                <Col sm={3} md={3} lg={3}>K</Col>
            </Row>
        );

        //Object.keys(this.props.properties).sort().forEach((key) => {
        Object.keys(this.props.properties).sort( (a, b) => parseInt(a.replace(/\D+/g, '')) - parseInt(b.replace(/\D+/g, '')) ).forEach((key) => {

            if (this.props.properties[key].info.name.includes(type)) {
                if(this.props.properties[key].value === 'Off'){
                    this.props.properties[key].value = 0
                }
                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                columns.push(
                    <Row style={{ margin: this.props.margin }}>
                        <Col sm={9} md={9} lg={9} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled={this.props.disabled}
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="number"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={this.props.properties[key].value}
                                onChange={this.handleChange} />
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                        <Col sm={3} md={3} lg={3}>K</Col>
                    </Row>
                );
            }
        });

        columns.push(
            <Row style={{ margin: this.props.margin }}>
                <Col sm={9} md={9} lg={9} key={`${this.props.properties['asttw.ci'].id}-1`}>
                    <input
                        id={`${this.props.properties['asttw.ci'].id}-1`}
                        disabled
                        className={'input-property-picker'}
                        name={this.props.properties['asttw.ci'].info.name}
                        type="number"
                        min={this.props.properties['asttw.ci'].valueMeta.min}
                        max={this.props.properties['asttw.ci'].valueMeta.max}
                        value={this.props.properties['asttw.ci'].value}
                        onChange={this.handleChange} />
                </Col>
                <Col sm={3} md={3} lg={3}>K</Col>
            </Row>
        );

        return columns;
    }

    render() {

        return (
            <div>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{whiteSpace: 'nowrap'}}>
                        <div className="card-header-feature">
                            {'Output Level'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            {this.renderFirstRow(this.props.firstRow.property)}
                        </Card.Body>
                    </Card>
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {'Time'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            {this.renderSecondRow(this.props.secondRow.property)}
                        </Card.Body>
                    </Card>
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {'Color'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            {this.renderThirdRow(this.props.thirdRow.property)}
                        </Card.Body>
                    </Card>
                </div>

            </div>

        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyTableTimePickerTW);
